import "./App.css";
import { Route, Switch } from "react-router-dom";
import Navbar from "./components/Navbar";
import Footer from "./components/Footer";
import Home from "./components/HOME/Home";
import About from "./components/About/About";
import Contact from "./components/Contact/Contact";
import Shop from "./components/Shop/Shop";
import ProductDetails from "./components/ProductDetails/ProductDetails";
import Error from "./components/Error404/Error";
import Signup from "./components/Registeration/Signup"
import Login from "./components/Registeration/Login"
function App() {
  return (
    <>
      <Navbar />
      <Switch>
        <Route exact path="/">
          <Home />
        </Route>
        <Route exact path="/about">
          <About />
        </Route>
        <Route exact path="/contact">
          <Contact />
        </Route>
        <Route exact path="/shop">
          <Shop />
        </Route>
        <Route exact path="/productDetails">
          <ProductDetails />
        </Route>
        <Route exact path="/signup">
          <Signup />
        </Route>

        <Route exact path="/login">
          <Login />
        </Route>
      

        <Route>
          <Error />
        </Route>
      </Switch>

      <Footer />
    </>
  );
}

export default App;
